import React from 'react';
import { Box } from '@mui/material';

/** Figma Ella-components node 1705:829 — mobile launcher leading icon. */
export const MobileLauncherStarGlyph = ({
  size = 12,
  color = '#FEFEFE',
  rotated = true,
}: {
  size?: number;
  color?: string;
  rotated?: boolean;
}): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      flexShrink: 0,
      transform: rotated ? 'rotate(-90deg)' : undefined,
    }}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M7.875 4.125L6 0L4.125 4.125L0 6L4.125 7.875L6 12L7.875 7.875L12 6L7.875 4.125Z"
        fill={color}
      />
    </svg>
  </Box>
);
